
import React from 'react';
import type { LucideProps } from 'lucide-react';

interface StatCardProps {
  title: string;
  value: string | number;
  Icon: React.ComponentType<LucideProps>;
  change?: string;
  changeColor?: string;
  iconBgColor?: string;
}

const StatCard: React.FC<StatCardProps> = ({ title, value, Icon, change, changeColor = 'text-teal-400 bg-teal-900/50', iconBgColor = 'from-teal-500 to-teal-600' }) => {
  return (
    <div className="glass-card rounded-xl p-6 hover-lift">
      <div className="flex items-center justify-between mb-4">
        <div className={`p-3 bg-gradient-to-br ${iconBgColor} rounded-lg`}>
          <Icon className="text-white" size={24} />
        </div>
        {change && (
          <span className={`text-xs font-semibold px-3 py-1 rounded-full ${changeColor}`}>{change}</span>
        )}
      </div>
      <h3 className="text-2xl font-bold text-white mb-1">{value}</h3>
      <p className="text-sm text-gray-400">{title}</p>
    </div>
  );
};

export default StatCard;
